import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Wrapper, Title, Inputs, Name, Phone, Email, ButtonBlock, Button, Agree, Message } from './styled';
import useSubmit from '../hooks/useSubmit';


const Form = ({ title, cityDomain, buttonText, textColor, formEmail, props }) => {

    const [phone, setPhone] = useState({});
    const [name, setName] = useState({});
    const [email, setEmail] = useState('');
    const [isValidInputs, setIsValidInputs] = useState(false);

    useEffect(() => {
        setIsValidInputs(phone.isValid && name.isValid);
    }, [phone, name]);

    const [{ status, isLoading, message }, doSubmit] = useSubmit(cityDomain, props);

    const submitHandler = e => {
        e.preventDefault();
        if (isValidInputs) {
            doSubmit({
                name: name.value,
                phone: phone.value,
                email: email
            });
        }
    };

    return (
        <Wrapper onSubmit={e => submitHandler(e)} textColor={textColor}>
            {
                status && message
                    ?   <Message>{message}</Message>
                    : <>
                            <Title dangerouslySetInnerHTML={{ __html: title }} />
                            <Inputs>
                                <Name
                                    name='name'
                                    formEmail={formEmail}
                                    onChange={stateInput => setName(stateInput)}
                                    placeholder='Ваше имя'
                                    errorMessage='Ожидаются только буквы и дефисы'
                                />
                                <Phone
                                    name='phone'
                                    formEmail={formEmail}
                                    onChange={stateInput => setPhone(stateInput)}
                                    placeholder='Номер телефона'
                                    errorMessage='Введите телефон в формате +7 (999) 999-99-99'
                                />
                                {
                                    formEmail &&
                                    <Email
                                        name='email'
                                        onChange={stateInput => {
                                            setEmail(stateInput);
                                        }}
                                        placeholder='Эл. почта'
                                        type='email'
                                        errorMessage='Введите корректный адрес эл.почты. Допускаются только латинские буквы, цифры, знаки _+.-'
                                        aria-label='E-mail'
                                        value={email}
                                        autoComplete='off'
                                    />
                                }
                            </Inputs>
                            <ButtonBlock>
                                <Button text={buttonText} disabled={!isValidInputs || isLoading}/>
                                <Agree textColor={textColor}>
                                    Нажимая на кнопку, вы соглашаетесь на обработку&nbsp;
                                    <a href='https://dom.ru/policy.pdf?_ga=2.194887981.1682807258.1580735380-296976907.1577435201'>
                                        персональных данных
                                    </a>
                                </Agree>
                            </ButtonBlock>
                        </>
            }
        </Wrapper>
    );
};

const mapStateToProps = state => ({
    cityDomain: state.city.currentCity.domain
});

export default connect(mapStateToProps)(Form);
